{
	"about": {
		"title": "O aplikacji",
		"version": "Wersja",
		"build-number": "Numer kompilacji",
		"new-version": "Nowa wersja"
	},
	"legal": {
		"privacy-policy": "Polityka prywatności",
		"terms-of-use": "Warunki korzystania"
	}
}
